// extracted by mini-css-extract-plugin
module.exports = {"title":"GuideTitle_title__wlxsH","subTitle":"GuideTitle_subTitle__2jF3F","rotate":"GuideTitle_rotate__2zV1L"};